import { Box, useMediaQuery, useTheme } from '@ublend-npm/aulaui-core';
import React, { useEffect } from 'react';
import AssignmentSidebar from './AssignmentSidebar/AssignmentSidebar';
import { createStyles } from './AssignmentResponsive.styles';
import {
  getBackButtonRoute,
  goToMySpaceNav,
} from '@core/constants/backButtonNavigation';
import NavigationBackHeader from '../../common/NavigationBackHeader/NavigationBackHeader';
import { getCurrentSpaceId } from '@core/selectors/space';
import { useSelector } from 'react-redux';
import { AulaState } from '@core/types/state';
import { selectCurrentAssignmentId } from '@core/assignments/selectors';
import pushRoute from '@app/utils/routing';
import AssignmentDetails from './AssignmentDetails/AssignmentDetails';

const getBackRoute = (spaceId) => {
  if (spaceId) {
    if (getBackButtonRoute()) {
      return getBackButtonRoute();
    } else {
      goToMySpaceNav(spaceId);
    }
  }

  return null;
};

const AssignmentsResponsive = () => {
  const theme = useTheme();
  const styles = createStyles(theme);
  const isMdUp = useMediaQuery(theme.breakpoints.up('md'));
  const state = useSelector((state) => state);
  const spaceId = getCurrentSpaceId(state as AulaState);
  const currentAssignmentId = useSelector(selectCurrentAssignmentId);
  const backRoute = getBackRoute(currentAssignmentId);
  const baseRoute = `/dashboard/${spaceId}/journey/assignments`;
  const mobileBackRoute = `${baseRoute}/list`;

  // First assignment in the list to which it will be redirected to
  const defaultAssignmentId = '169be44a-3ec0-4d41-97d9-4e05381af71e';

  // Redirect to the first assignment if currentAssignmentId is null.
  useEffect(() => {
    if (currentAssignmentId) {
      return;
    }

    pushRoute(`${baseRoute}/${defaultAssignmentId}?from=myspacenav`);
  }, [defaultAssignmentId]);

  // If isMdUp is true and currentAssignmentId is "list",
  // redirect to the first assignment instead of showing the list page.
  useEffect(() => {
    if (isMdUp && currentAssignmentId == 'list') {
      pushRoute(`${baseRoute}/${defaultAssignmentId}`);
    }
  }, [isMdUp]);

  const getContent = () => {
    if (isMdUp) {
      return (
        <Box sx={styles.containerWrapper}>
          <Box sx={styles.leftWrapper}>
            <AssignmentSidebar backRoute={backRoute} spaceId={spaceId} />
          </Box>
          <Box sx={{ flex: '1', padding: '40px 1.5rem 1rem' }}>
            <AssignmentDetails />
          </Box>
        </Box>
      );
    } else {
      return (
        <Box sx={styles.pageWrapper}>
          <Box sx={styles.buttonWrapper}>
            <NavigationBackHeader route={mobileBackRoute} />
          </Box>
          <Box sx={styles.pageContent}>
            <AssignmentDetails />
          </Box>
        </Box>
      );
    }
  };

  return (
    <>
      {currentAssignmentId == 'list' ? (
        <Box sx={{ height: '100%' }}>
          <AssignmentSidebar backRoute={backRoute} spaceId={spaceId} />
        </Box>
      ) : (
        <Box>{getContent()}</Box>
      )}
    </>
  );
};

export default AssignmentsResponsive;
